
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'MSDC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/MSDC.vue